import React from "react";
import Navbar from "../components/navbar";
import "../css/schedule.css";
import { db } from "../firebaseConfig";
import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";

const Schedule = () => {
  const [currentDaySchedule, setCurrentDaySchedule] = useState([]);
  const [day1, setDay1] = useState([]);
  const [day2, setDay2] = useState([]);
  const [day3, setDay3] = useState([]);
  const [day4, setDay4] = useState([]);
  
  useEffect(() => {
    let day1array = [];
    let day2array = [];
    let day3array = [];
    let day4array = [];
    getDocs(collection(db, "schedule")).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let schedule = {
          title: doc.data().event,
          since: doc.data().startTime.toDate().toLocaleTimeString(),
          till: doc.data().endTime.toDate().toLocaleTimeString(),
          location: doc.data().location,
          date: doc.data().date,
          timestamp: doc.data().startTime,
        };

        if (schedule.date === "1") {
          day1array.push(schedule);
        } else if (schedule.date === "2") {
          day2array.push(schedule);
        } else if (schedule.date === "3") {
          day3array.push(schedule);
        } else if (schedule.date === "4") {
          day4array.push(schedule);
        }
      });
      day1array.sort((x,y) => {
        return x.timestamp - y.timestamp;
      });
      day2array.sort((x,y) => {
        return x.timestamp - y.timestamp;
      });
      day3array.sort((x,y) => {
        return x.timestamp - y.timestamp;
      });
      day4array.sort((x,y) => {
        return x.timestamp - y.timestamp;
      });
      

      setDay1(day1array);
      setDay2(day2array);
      setDay3(day3array);
      setDay4(day4array);
      setCurrentDaySchedule(day1array);
      console.log(day1);
      console.log(day2);
      console.log(day3);
      console.log(day4);
      console.log(currentDaySchedule);
    });
  }, []);

  const changeDay = (day) => {
    if (day === 1) {
      setCurrentDaySchedule(day1);
    } else if (day === 2) {
      setCurrentDaySchedule(day2);
    } else if (day === 3) {
      setCurrentDaySchedule(day3);
    } else if (day === 4) {
      setCurrentDaySchedule(day4);
    }
  };

  return (
    <>
      <Navbar />
      <div className="app__schedule">
        <div className="schedule__days">
          <button
            className="active__day schecule__day"
            onClick={() => changeDay(1)}
          >
            <h3>Day 1</h3>
          </button>
          <button className="schecule__day" onClick={() => changeDay(2)}>
            <h3>Day 2</h3>
          </button>
          <button className="schecule__day" onClick={() => changeDay(3)}>
            <h3>Day 3</h3>
          </button>
          <button className="schecule__day" onClick={() => changeDay(4)}>
            <h3>Day 4</h3>
          </button>
        </div>
        <div className="schedule__events">
          {currentDaySchedule.map((event) => (
            <div className="schedule__card">
              <div className="row row-cols-md-3 row-cols-1">
                <div className="schedule__title col">
                  <h3>{event.title}</h3>
                </div>
                <div className="schedule__time col">
                  <h3>
                    {event.since} - {event.till}
                  </h3>
                </div>
                <div className="schedule__location col">
                  <h3>{event.location}</h3>
                </div>
              </div>
            </div>
          ))}
          ;
        </div>
      </div>
    </>
  );
};

export default Schedule;
